// extracted by mini-css-extract-plugin
export default {"headerContainer":"style_headerContainer__IU-Dz","logo":"style_logo__qunXJ","logo2":"style_logo2__zfeDj"};